import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PremiumPageComponent } from './premium-page.component';

@NgModule({
    declarations: [PremiumPageComponent],
    imports: [CommonModule, FormsModule],
    exports: [PremiumPageComponent]
})
export class PremiumPageModule { }
